import { isNumber } from 'lodash';

export function convertToFinalPrice(retail_price, final_price) {
    if (window.clientData.enable_golf && final_price !== false && isNumber(final_price)) {
        return final_price;
    }
    return retail_price;
}
